module.exports = require("prop-types-exact");